/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactBaseResponseDto } from './subjectContactBaseResponseDto.model';
import { ContractRole } from './contractRole.model';


/**
 * Signatory of the contract as computed by the backend: the contract party itself, its representative or a partner of an SJM party.
 */
export interface SignatureParticipantResponseDto { 
    /**
     * Role of the contract party in the contract.
     */
    contractRole: ContractRole;
    /**
     * Contract party the signatory signs for (the represented party or the SJM subject); null when the party signs itself.
     */
    parentSubject?: SubjectContactBaseResponseDto;
    /**
     * Subject of the person who signs (the contract party itself, its representative or an SJM partner). Its id is the subjectId to send in the start signing request.
     */
    subject: SubjectContactBaseResponseDto;
}
export namespace SignatureParticipantResponseDto {
}


